import styled from "styled-components";

export const MainContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-self: center;
  justify-content: space-between;
  flex-direction: column;
  .step-container{
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 50px;
    padding: 20px 50px;
  }
  .steps{
    display: flex;
    justify-content: center;
  }

  .step-content {
    width: 100%;
    padding: 25px 30px;
    display: flex;
    flex-direction: column;
    border: 1px solid var(--gray-light);
    border-radius: 10px;
    gap: 10px;
  }

  .buttons {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
`;